import { useMutation, UseMutationOptions } from '@tanstack/react-query';

import { checkoutApi } from 'src/api';
import {
  PaymentMethodPayload,
  ValidationChargeParams,
  ValidationChargeResponse,
} from 'src/types/api';
import { PaymentMethod, Uid } from 'src/types/dto';

const postWallet = (payload: PaymentMethodPayload) =>
  checkoutApi.post<PaymentMethod>('wallet', payload).then(res => res.data);

const postWalletValidate = ({ id, ...payload }: ValidationChargeParams) =>
  checkoutApi
    .post<ValidationChargeResponse>(`wallet/${id}/validate`, payload)
    .then(res => res.data);

export const deleteWallet = (id: Uid) =>
  checkoutApi.delete<void>(`wallet/${id}`).then(res => res.data);

export const useCheckoutWalletMutation = (
  options?: UseMutationOptions<PaymentMethod, Error, PaymentMethodPayload>,
) => {
  return useMutation<PaymentMethod, Error, PaymentMethodPayload>({
    mutationFn: postWallet,
    ...options,
  });
};

export const useCheckoutWalletValidateMutation = (
  options?: UseMutationOptions<
    ValidationChargeResponse,
    Error,
    ValidationChargeParams
  >,
) => {
  return useMutation<ValidationChargeResponse, Error, ValidationChargeParams>({
    mutationFn: postWalletValidate,
    ...options,
  });
};
